(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veyra-bundle-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veyra-bundle-selector')) {
    customElements.define('veyra-bundle-selector', class extends HTMLElement {
      getValue() { return Number(this.querySelector('input:checked')?.value || 1); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
